<!-- <div class="infographic infographic-images d-none d-lg-flex">
<div class="infographic__item" *ngFor="let slide of images; let i = index">
  <img [src]="slide.imageUrl" [alt]="slide.caption || diseaseProfileTitle + ' infographic afbeelding ' + i" />
</div>
</div> -->
<section class="mb-5">
  @if (images()?.length) {
    <div class="container d-sm-flex justify-content-between align-items-end">
      @if (!('infographic-titel' | fromDictionary).startsWith('TEXT NOT FOUND FOR')) {
        <h2 class="h2">{{ 'infographic-titel' | fromDictionary }}</h2>
      }
    </div>
  }
  @if (images()?.length) {
    <ngx-glide
      [gap]="-1"
      [showArrows]="true"
      [perView]="3"
      [arrowLeftTemplate]="arrowLeftTemplate"
      [arrowRightTemplate]="arrowRightTemplate"
      [listenToEvents]="true"
      [hoverpause]="true"
      [rewind]="true"
      [bound]="true"
      [animationDuration]="200"
      class="infographic infographic-slider d-block"
      [breakpoints]="{
        '768': { perView: 1.2 },
        '1620': { perView: 3 },
      }"
    >
      @for (slide of images(); track slide; let i = $index) {
        <div class="infographic__item">
          <img [src]="slide.imageUrl" [alt]="slide.caption || diseaseProfileTitle() + ' infographic afbeelding ' + i" />
        </div>
      }
    </ngx-glide>
  }

  <ng-template #arrowLeftTemplate>
    <div class="infographic-slider__arrow infographic-slider__arrow--left">
      <button>
        <fstr-icon [ariaHidden]="true" anchor="icon-arrow-left"></fstr-icon>
        <span>vorige</span>
      </button>
    </div>
  </ng-template>

  <ng-template #arrowRightTemplate>
    <div class="infographic-slider__arrow infographic-slider__arrow--right">
      <button>
        <span>volgende</span>
        <fstr-icon [ariaHidden]="true" anchor="icon-arrow-right"></fstr-icon>
      </button>
    </div>
  </ng-template>

  @if (knowledgeCardsUrl()) {
    <div class="container" [class.has--no-infographic]="!images()?.length">
      <a [href]="knowledgeCardsUrl()" class="infographic__more bg-gradient-primary d-flex block-link text-left">
        <h1 class="text-white h5">Bekijk ook eens de kenniskaarten</h1>
        <span class="button button-icon button-icon--light button--sm">
          <fstr-icon [ariaHidden]="true" anchor="icon-arrow-right"></fstr-icon>
        </span>
      </a>
    </div>
  }
</section>
